import { useHttpClient } from '@ioip/core/lib/providers/AuthenticationProvider';
import React, { useContext, useRef } from 'react';
import { IProcesoxEngineOverrideApi } from '../core/IProcesoxEngineOverrideApi';
import { JSEngine } from '../forms/types/JSEngine';

const $Context = React.createContext<{ baseUrl: string }>(null);

export interface IProcesoxProviderProps {
    baseUrl: string;
    override?: IProcesoxEngineOverrideApi;
}

export const ProcesoxProvider = (props: React.PropsWithChildren<IProcesoxProviderProps>): JSX.Element => {
    return <$Context.Provider value={props}>
        {props.children}
    </$Context.Provider>
}

/**
 * Hook encargado de dar acceso al Sdk de Archivox/Tramitex/Procesox
 * @param props 
 * @returns 
 */
export const useProcesox = (): JSEngine => {

    const context = useContext($Context);
    const sdkRef = useRef<JSEngine>(null);
    const httpClient = useHttpClient(context.baseUrl, 'procesox');

    if (context == null)
        throw new Error('No es posible acceder al contexto de tramitex, verifique que el componente esté dentro del proveedor <ProcesoxProvider />')
    if (sdkRef.current == null)
        sdkRef.current = new JSEngine({ httpClient });

    return sdkRef.current;

}
